<template>
   <v-layout wrap
      justify-center
   >
      <v-flex xs12>
         <center>
         <v-date-picker
           v-model="date2"
           :event-color="date => date[9] % 2 ? 'red' : 'yellow'"
           :events="functionEvents"
           :month="test"
          :picker-date.sync="pickerDate"
         />
         </center>
      </v-flex>
   </v-layout>
</template>
<script>
export default {
   data: () => ({
      pickerDate: null,
      arrayEvents: null,
      date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    }),
   watch: {
      pickerDate (v) {
         alert(v)
      },
   },
    mounted () {
      this.arrayEvents = [...Array(6)].map(() => {
        const day = Math.floor(Math.random() * 30)
        const d = new Date()
        d.setDate(day)
        return d.toISOString().substr(0, 10)
      })
    },

    methods: {
      functionEvents (date) {
        const [,, day] = date.split('-')
        if ([12, 17, 28].includes(parseInt(day, 10))) return true
        if ([1, 19, 22].includes(parseInt(day, 10))) return ['red', '#00f']
        return false
      },
       test(v) {
          alert(v)
       }
    },
}
</script>

